import { EmployeeStatus } from '@/common/graphql';
import { EmployeeStatusLabels } from '@/common/types';
import { ObjectUtils } from '@/common/utils';

import { EmployeeStatusBadge } from '../../badge';
import type { ComboboxItemWithFormatted } from '../props';
import { SelectMultiple, type SelectMultipleProps } from '../SelectMultiple';

interface EmployeeStatusSelectMultipleProps
  extends Omit<SelectMultipleProps<ComboboxItemWithFormatted<EmployeeStatus>>, 'searchable' | 'value'> {
  value: Array<EmployeeStatus> | null | undefined;
}

const sortOrder = [EmployeeStatus.Active, EmployeeStatus.PreOnboarding, EmployeeStatus.Inactive];

const data: Array<ComboboxItemWithFormatted<EmployeeStatus>> = ObjectUtils.arrayFromEnumValues<EmployeeStatus>(
  EmployeeStatus,
)
  .sort((a, b) => sortOrder.indexOf(a) - sortOrder.indexOf(b))
  .map(value => ({
    label: EmployeeStatusLabels[value],
    labelFormatted: <EmployeeStatusBadge status={value} />,
    value,
  }));

export const EmployeeStatusSelectMultiple = ({
  placeholder = 'Select status',
  ...rest
}: EmployeeStatusSelectMultipleProps) => (
  <SelectMultiple
    {...rest}
    data={data}
    loading={false}
    multipleSelectedLabel={length => `${length} statuses`}
    placeholder={placeholder}
    searchable={false}
  />
);
